export default __webpack_public_path__ + "static/media/1_0006.9afe29f3.webp";